export default __webpack_public_path__ + "static/media/people_colored.5103b75f.png";